import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {NzBreadCrumbModule} from 'ng-zorro-antd/breadcrumb';
import {NzSpinModule} from 'ng-zorro-antd/spin';

import {LocationStrategy, PathLocationStrategy, registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';

import {AppRoutingModule} from './app-routing.module';
import {TemplateModule} from './shared/template/template.module';
import {SharedModule} from './shared/shared.module';

import {BaseChartDirective} from 'ng2-charts';
import {NgApexchartsModule} from "ng-apexcharts";
import {AngularSvgIconModule} from 'angular-svg-icon';
import {FullCalendarModule} from '@fullcalendar/angular';

import {AppComponent} from './app.component';
import {CommonLayoutComponent} from './layouts/common-layout/common-layout.component';
import {FullLayoutComponent} from './layouts/full-layout/full-layout.component';
import {ThemeConstantService} from './shared/services/theme-constant.service';
import {NZ_DATE_CONFIG} from "ng-met-antd/i18n";
import {CheckAuthInterceptor} from "./interceptors/check-auth-interceptor";
import {JwtAuthInterceptor} from "./interceptors/jwt-auth-interceptor";
import {ErrorHandlerInterceptor} from "./interceptors/error-handler-interceptor";

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    CommonLayoutComponent,
    FullLayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TemplateModule,
    SharedModule,
    NzBreadCrumbModule,
    NzSpinModule,
    BaseChartDirective,
    NgApexchartsModule,
    FullCalendarModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot()
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(),),
    {provide: HTTP_INTERCEPTORS, useClass: CheckAuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: JwtAuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true},
    {
      provide: NZ_I18N,
      useValue: en_US,
    },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    {
      provide: NZ_DATE_CONFIG, useValue: {
        displayFormats: {
          veryShortWeekLabel: 'dd',
          dateInput: 'yyyy/MM/DD',
          dateTimeInput: 'yyyy-MM-DD HH:mm:ss'
        }
      }
    },
    ThemeConstantService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
